<template>
  <div>
    <div class="" v-for="(message, index) in array" :key="index">

      <md-field :class="isInvalid(index)" class="inputLink" :md-clearable="true">
        <label class="labelMidias">Mídias (YouTube/Instagram/Soundcloud)</label>
        <md-input type="url" v-model="message.url" @input="changed"></md-input>
        <span class="md-error">Link inválido!</span>
      </md-field>

      <!-- <md-button
        v-if="array[index].url"
        class="md-icon-button md-raised md-accent buttonUndoClear"
        @click="undo(index)"
      >
        <md-icon>undo</md-icon>
      </md-button> -->
      <md-button
        v-if="!array[index].url && array.length > 1"
        class="md-icon-button md-raised md-accent buttonUndoClear"
        @click="clear(index)"
      >
        <md-icon>undo</md-icon>
      </md-button>
    </div>
    <div>
      <md-button
        class="md-raised md-primary buttonAdd"
        v-show="array[array.length-1].url != ''"
        @click="add()"
      >
        <md-icon>add</md-icon>
      </md-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'invalid'],
  data() {
    return {
      array: this.value? this.value : [{ url: "" }],
      // array: this.value? this.value.map(v => ({ url: v })) : [{ url: "" }],
    }
  },
  methods: {
    changed() {
      this.$emit('input', this.array);
      // this.$emit('input', this.array.map(a => a.url));
    },
    undo(index) {
      this.array[index].url = "";
      this.changed();
    },
    clear(index) {
      this.array.splice(index, 1);
      this.changed();
    },
    add() {
      this.array.push({ url: "" });
      this.changed();
    },
    isInvalid(index) {
      return {
        'md-invalid': this.invalid && this.invalid.includes(index)
      };
    }
  },
}
</script>

<style scoped>
/* .inputLink{
  width: 50%;
} */

.inputCreateURLs {
  display: inline-block;
  width: 90%;
  padding: 12px 20px;
  margin: 8px 0;
  border: 1px solid #ccc;
}

.buttonUndoClear {
  float: right;
  margin: 5px auto;
}

.buttonAdd {
  float: right;
}

@media (max-width: 320px) {
  .labelMidias{
    top: 0;
  }
}
</style>
